<template>
  <div class="poster-wrap">
    <!-- <el-dialog
      title="修改交易对设置"
      width="800px"
      :visible="updateDialog"
      @close="closeDialog"
      @open="getList"
    >
      <el-form ref="form" label-width="130px" :model="form">
        <el-form-item label="交易对：" prop="pair">
          {{ form.pair }}
        </el-form-item>
        <el-form-item label="默认精度：" prop="defaultPrecision">
          {{ form.defaultPrecision }}
        </el-form-item>
        <el-form-item label="数量精度：" prop="amountPrecision">
          {{ form.amountPrecision }}
        </el-form-item>
        <el-form-item label="手续费：" prop="tradeFee">
          <el-input-number
            v-model="form.tradeFee"
            :min="0"
            :max="1"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog> -->
  <el-dialog v-bind="$attrs" v-on="$listeners" 
      width="1400px"
      :visible.sync="updateDialog"
      @open="getList"
      @close="closeDialog"
      :before-close="handleClose"
      title="编辑交易对">
  <el-form  ref="tradePairForm" :model="tradePair" :rules="rules" size="medium" label-width="100px">
    <el-row :gutter="15">
      <el-col :span="12">
        <el-form-item label="标的币种" prop="buyCoin" label-width="140px">
          <!-- <el-select v-model="tradePair.buyCoin" placeholder="请选择标的币种" clearable :style="{width: '100%'}">
            <el-option v-for="(item, index) in buy_coinOptions" :key="index" :label="item.label"
              :value="item.value" :disabled="item.disabled"></el-option>
          </el-select> -->
           <el-input v-model="tradePair.buyCoin" placeholder="请输入标的币种" clearable :style="{width: '100%'}">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="报价币种" prop="sellCoin" label-width="140px">
          <!-- <el-select v-model="tradePair.sell_coin" placeholder="请选择报价币种" clearable :style="{width: '100%'}">
            <el-option v-for="(item, index) in sell_coinOptions" :key="index" :label="item.label"
              :value="item.value" :disabled="item.disabled"></el-option>
          </el-select> -->
          <el-input v-model="tradePair.sellCoin" placeholder="请输入报价币种" clearable :style="{width: '100%'}">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="交易对隐藏开关" prop="symbolSwitch" required label-width="140px">
          <el-switch v-model="tradePair.symbolSwitch" active-color="#09EF34" inactive-color="#FE1212">
          </el-switch>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="交易开关" prop="tradeSwitch" required label-width="140px">
          <el-switch v-model="tradePair.tradeSwitch" active-color="#09EF34" inactive-color="#FE1212">
          </el-switch>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="热门开关" prop="hot" required label-width="140px">
          <el-switch v-model="tradePair.hot" active-color="#09EF34" inactive-color="#FE1212">
          </el-switch>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="交易对状态" prop="state" required label-width="140px">
          <!-- <el-switch v-model="tradePair.state" active-color="#09EF34" inactive-color="#FE1212"></el-switch> -->

          <el-select  v-model="tradePair.state" placeholder="请选择交易对状态" clearable
            :style="{width: '100%'}">
            <el-option v-for="(item, index) in stateOptions" :key="index" :label="item.label"
              :value="item.value" :disabled="item.disabled"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="symbolGroupId" prop="symbolGroupId" label-width="140px">
          <el-input-number v-model="tradePair.symbolGroupId" placeholder="symbolGroupId"></el-input-number>
        </el-form-item>
      </el-col>
    </el-row>
     <el-row :gutter="15">
      <!-- <el-col :span="12">
        <el-form-item label="计划类型委托" prop="supportEntrustType" label-width="140px">
         
          <div class="sub-title">1：限价止盈，2：限价止损，3：市价止盈，4：市价止损(数字用英文逗号隔开)</div>
          <el-input v-model="tradePair.supportEntrustType" placeholder="请输入计划类型委托" clearable
            :style="{width: '100%'}"></el-input>
        </el-form-item>
      </el-col> -->
      <el-col :span="12">
        <el-form-item label="标的币种数量精度" prop="buyCoinPrecision" label-width="140px">
          <el-input-number v-model="tradePair.buyCoinPrecision" placeholder="标的币种数量精度"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="订单类型"  prop="supportOrderType"  label-width="140px">
          <!-- <el-select  multiple v-model="tradePair.supportOrderType" placeholder="请选择订单类型" clearable
            :style="{width: '100%'}">
            <el-option v-for="(item, index) in support_order_typeOptions" :key="index" :label="item.label"
              :value="item.value" :disabled="item.disabled"></el-option>
          </el-select> -->
          <el-select v-model="tradePair.supportOrderType" multiple placeholder="请选择">
              <el-option
                v-for="item in support_order_typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          <!-- <div class="sub-title">1：限价单，2：市价单，(数字用英文逗号隔开)</div>
          <el-input v-model="tradePair.supportOrderType" placeholder="请输入上面提示中的数字" clearable
            :style="{width: '100%'}"></el-input> -->
        </el-form-item>
      </el-col>
      <el-col :span="12">
      
        <el-form-item label="有效方式" prop="supportTimeInForce" label-width="140px">
          <div class="sub-title">1：GTC，2：IOC，3：FOK，4：GTX(数字用英文逗号隔开)</div>
          <el-input v-model="tradePair.supportTimeInForce" placeholder="请输入有效方式" clearable
            :style="{width: '100%'}"></el-input>
          <!-- <el-select multiple v-model="tradePair.supportTimeInForce" placeholder="请选择有效方式" clearable
            :style="{width: '100%'}">
            <el-option v-for="(item, index) in support_time_in_forceOptions" :key="index" :label="item.label"
              :value="item.value" :disabled="item.disabled"></el-option>
          </el-select> -->
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="市价最大吃单阈值" prop="marketTakeBound" label-width="140px">
          <!-- <el-select v-model="tradePair.marketTakeBound" placeholder="请选择市价最大吃单阈值" clearable
            :style="{width: '100%'}">
            <el-option v-for="(item, index) in market_take_boundOptions" :key="index" :label="item.label"
              :value="item.value" :disabled="item.disabled"></el-option>
          </el-select> -->
                    <el-input-number v-model="tradePair.marketTakeBound" placeholder="市价最大吃单阈值"></el-input-number>

        </el-form-item>
      </el-col>
      <el-col :span="12">
        <!-- <el-form-item label="后缀图标" prop="lastIcon" label-width="140px">
          <el-select v-model="tradePair.lastIcon" placeholder="请选择后缀图标" clearable :style="{width: '100%'}">
            <el-option v-for="(item, index) in last_iconOptions" :key="index" :label="item.label"
              :value="item.value" :disabled="item.disabled"></el-option>
          </el-select>
        </el-form-item> -->
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="12">
        <el-form-item label="报价的币种精度" prop="sellCoinPrecision" label-width="140px">
          <el-input-number v-model="tradePair.sellCoinPrecision" placeholder="报价的币种精度"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="最小交易单位" prop="minQty" label-width="140px">
          <el-input v-model="tradePair.minQty" placeholder="请输入最小交易单位" clearable :style="{width: '100%'}">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="交易对价格精度" prop="pricePrecision" label-width="140px">
          <el-input-number v-model="tradePair.pricePrecision" placeholder="交易对价格精度"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="最小价格变动单位" prop="minStepPrice" label-width="140px">
          <el-input v-model="tradePair.minStepPrice" placeholder="请输入最小价格变动单位" clearable
            :style="{width: '100%'}"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="最大买单价格上浮" prop="multiplierUp" label-width="140px">
          <el-input v-model="tradePair.multiplierUp" placeholder="请输入最大买单价格上浮" clearable
            :style="{width: '100%'}"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="最大卖单价格下浮" prop="multiplierDown" label-width="140px">
          <el-input v-model="tradePair.multiplierDown" placeholder="请输入最大卖单价格下浮" clearable
            :style="{width: '100%'}"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="12">
        <el-form-item label="maker手续费率" prop="makerFee" label-width="140px">
          <el-input-number v-model="tradePair.makerFee" placeholder="maker手续费率"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="sequence" prop="sequence" label-width="140px">
          <el-input-number v-model="tradePair.sequence" placeholder="sequence"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="数量精度" prop="quantityPrecision" label-width="140px">
          <el-input-number v-model="tradePair.quantityPrecision" placeholder="quantityPrecision"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="盘口精度合并" prop="depthPrecisionMerge" label-width="140px">
          <el-input-number v-model="tradePair.depthPrecisionMerge" placeholder="盘口精度合并"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="taker手续费率" prop="takerFee" label-width="140px">
          <el-input-number v-model="tradePair.takerFee" placeholder="taker手续费率"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="用户id" prop="uids" label-width="140px">
          <div class="sub-title">(如需填写多个id，id用英文逗号隔开)</div>
          <el-input v-model="tradePair.uids" placeholder="请输入用户id" clearable
            :style="{width: '100%'}"></el-input>
          <!-- <el-select multiple v-model="tradePair.supportTimeInForce" placeholder="请选择有效方式" clearable
            :style="{width: '100%'}">
            <el-option v-for="(item, index) in support_time_in_forceOptions" :key="index" :label="item.label"
              :value="item.value" :disabled="item.disabled"></el-option>
          </el-select> -->
        </el-form-item>
      </el-col>
      
    </el-row>
    <el-row :gutter="15">
      <el-col :span="12">
      
        <el-form-item label="上线日期" prop="onboardDate" label-width="140px">
          <!-- <el-date-picker v-model="tradePair.onboardDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            :style="{width: '100%'}" placeholder="请选择上线日期" clearable></el-date-picker> -->
              <!-- <div class="sub-title" >时间需要每次重新选择确认</div> -->
              <el-date-picker
      v-model="tradePair.onboardDate"
      type="datetime"
      placeholder="选择日期时间">
    </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <!-- <el-form-item label="交割日期" prop="deliveryTime" label-width="140px">
          <el-date-picker v-model="tradePair.deliveryTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            :style="{width: '100%'}" placeholder="请选择上线日期" clearable></el-date-picker>
        </el-form-item> -->
      </el-col>
      <!-- <el-col :span="12">
        <el-form-item label="创建时间" prop="createdTime" label-width="140px">
          <el-date-picker v-model="tradePair.createdTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            :style="{width: '100%'}" placeholder="请选择上线日期" clearable></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="更新时间" prop="updatedTime" label-width="140px">
         <el-date-picker v-model="tradePair.updatedTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            :style="{width: '100%'}" placeholder="请选择上线日期" clearable></el-date-picker>
        </el-form-item>
      </el-col> -->
    </el-row>
  </el-form>
  <div slot="footer">
    <el-button @click="closeDialog">取消</el-button>
    <el-button type="primary" @click="handleSave('tradePairForm')">保存</el-button>
  </div>
</el-dialog>

 </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  props: ['val1', 'buyCoin','state'],
  data() {
    return {
      form: {},
      dialogVisible:false,
       tradePair: {
        supportOrderType:[]
       },
       rules: {
        // exchangeCoin: [{ required: true, message: '请选择交易目标币种' }],
        // anchoredCoin: [{ required: true, message: '请选择锚定币种' }],
        // defaultPrecision: [{ required: true, message: '请输入默认精度' }],
        // amountPrecision: [{ required: true, message: '请输入数量精度' }],
        // tradeFee: [{ required: true, message: '请输入手续费' }]
        supportOrderType: [
          { required: true, message: "请选择支持的订单类型" },
        ],
        sequence: [
          { required: true, message: "请输入sequence" },
        ],
        quantityPrecision: [
          { required: true, message: "请输入数量精度" },
        ],
        supportTimeInForce: [
          { required: true, message: "请选择支持的有效方式（英文逗号分隔）" },
        ],
        supportEntrustType: [
          {
            required: true,
            message: "请选择支持的计划类型委托（英文逗号分隔）",
          },
        ],
        state: [{ required: true, message: "请选择交易对状态" }],
        buyCoin: [{ required: true, message: "请选择标的币种" }],
        sellCoin: [{ required: true, message: "请选择报价的币种" }],
        buyCoinPrecision: [
          { required: true, message: "请选择标的币种数量精度" },
        ],
        sellCoinPrecision: [
          { required: true, message: "请选择报价的币种精度" },
        ],
        pricePrecision: [{ required: true, message: "请选择交易对价格精度" }],
        minQty: [{ required: true, message: "请选择最小交易单位" }],
        minStepPrice: [{ required: true, message: "请选择最小价格变动单位" }],
        multiplierUp: [{ required: true, message: "请选择最大买单价格上浮" }],
        multiplierDown: [
          { required: true, message: "请选择最大卖单价格下浮" },
        ],
        marketTakeBound: [
          { required: true, message: "请选择市价单最大吃单阈值" },
        ],
        takerFee: [{ required: true, message: "请选择taker手续费率" }],
        makerFee: [{ required: true, message: "请选择maker手续费率" }],
        depthPrecisionMerge: [{ required: true, message: "请选择盘口精度" }],
        // lastIcon: [{ required: true, message: "请选择后缀图标" }],
        symbolSwitch: [{ required: true, message: "请选择合约状态" }],
        tradeSwitch: [{ required: true, message: "请选择交易状态" }],
        onboardDate: [{ required: true, message: "请选择上限日期" }],
        deliveryTime: [{ required: true, message: "请选择交割日期" }],
        createdTime: [{ required: true, message: "创建时间" }],
        updatedTime: [{ required: true, message: "更新时间" }],
      },
        buy_coinOptions: [{
        "label": "选项一",
        "value": 1
      }],
      stateOptions:[
        {
        "label": "待上市",
        "value": 0
      },
        {
        "label": "交易中",
        "value": 1
      },
        {
        "label": "已下架",
        "value": 2
      }
      ],
      sell_coinOptions: [{
        "label": "选项一",
        "value": 1
      }, {
        "label": "选项二",
        "value": 2
      }],
      support_entrust_typeOptions: [{
        "label": "限价止盈",
        "value": 1
      },{
        "label": "限价止损",
        "value": 2
      },{
        "label": "市价止盈",
        "value": 3
      },{
        "label": "市价止损",
        "value": 4
      }],
     support_order_typeOptions: [{
        "label": "限价单",
        "value": '1'
      }, {
        "label": "市价单",
        "value": '2'
      }],
      support_time_in_forceOptions: [{
        "label": "GTC",
        "value": 1
      }, {
        "label": "IOC",
        "value": 2
      }, {
        "label": "FOK",
        "value": 3
      }, {
        "label": "GTX",
        "value": 4
      }
      ],
      market_take_boundOptions: [{
        "label": "选项一",
        "value": 1
      }],
      // last_iconOptions: [{
      //   "label": "选项一",
      //   "value": 1
      // }],
    };
  },
  watch: {
    val1:{
      handler(val,oldVal){
        // this.tradePair={...val}
        console.log('val',val);
        this.tradePair={...val}
        // if(val){
        //   if(val.supportOrderType.length==1){
        //   this.tradePair = {...val} ;
        //   // this.tradePair = {...val,supportOrderType:[String(val.supportOrderType)]} ;
      
        // }
        // if(val.supportOrderType.length==3){
        //   this.tradePair={...val}
        //   // this.tradePair={...val,supportOrderType:['1','2']}
        // }
        // }
       
//  this.tradePair = {...this.val1,supportOrderType:Number(this.val1.supportOrderType)} ;
      },
      immediate:true,
      deep:true
    }
  },
  mounted() {

  },
  computed: {
    ...mapState('tradePairSetting', ['updateDialog','pagination',]),
    
  },
  methods: {
    ...mapActions('tradePairSetting', ['updateTradePair', 'list','updateSymbol']),
    ...mapMutations('tradePairSetting', ['setUpdaterDialog']),
    // ...mapActions('ctf', ['getCtflist']),
    closeDialog() {
      this.setUpdaterDialog(false);
      this.tradePair={
        supportOrderType:[]
      }
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            this.setUpdaterDialog(false);
            this.tradePair={
            supportOrderType:[]
            }
            done();
          })
          .catch(_ => {});
      },

    handleSave(tradePairForm) {
      // console.log('this.aaa',this.pagination);
      const symbol=this.tradePair.sellCoin+'_'+this.tradePair.buyCoin
       const obj={
        ...this.tradePair,
       symbol,
       onboardDate:this.tradePair.onboardDate.valueOf(),
       supportOrderType:this.tradePair.supportOrderType.join(',')
      }
      console.log('obj',obj);
      this.$refs[tradePairForm].validate(async(valid) => {
        if (valid) {
        const res=await  this.updateSymbol(obj)
            if(res.code==0){
            this.$message.success(res.msg);
            this.closeDialog()
            this.$emit("refresh", {page:this.pagination.page,size:this.pagination.size,buyCoin:this.buyCoin,symbol:'',state:this.state });
            }
        }
      });
     
      // this.closeDialog()
    },
   async getList() {}
  },
  components: {},
 
  
};
</script>
<style lang="less">
.sub-title{
  color: red;
}
</style>
